import { Badge, Icon, IconButton } from '@mui/material'

export default function AnnouncementsIcon({ announcements = [], onOpen }) {
    if (announcements.length === 0) {
        return null
    }

    const unseen = announcements.filter((announcement) => !announcement.isSeen)
    const hasUnseenAlert = unseen.some((announcement) => announcement.type?.key === 'alert')

    return (
        <IconButton aria-label="מודעות" onClick={() => onOpen?.()}>
            <Badge
                badgeContent={unseen.length === 0 ? null : (
                    <span data-testid="announcements-unseen-count">{unseen.length}</span>
                )}
                color={hasUnseenAlert ? 'error' : 'info'}
            >
                <Icon
                    data-testid={hasUnseenAlert ? 'announcements-icon-alert' : 'announcements-icon'}
                    color={unseen.length === 0 ? 'disabled' : 'inherit'}
                >
                    campaign
                </Icon>
            </Badge>
        </IconButton>
    )
}
